import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { pingSessionLog, getLogId } from './session';

const PING_MS = 60 * 1000; // 1 minute

// Mounted once inside the authenticated shell (Layout). While a user is signed
// in, pings the server every minute to advance the session's LogOutTime, so the
// last ping = effective logout. Runs on both web and APK (per spec).
export default function usePingLog() {
  const { user } = useAuth();
  useEffect(() => {
    if (!user || !getLogId()) return undefined;
    // Fire one immediately so a short visit still records beyond LoginTime.
    pingSessionLog();
    const t = setInterval(pingSessionLog, PING_MS);
    // Also ping when the tab/app regains focus (covers wake-from-background).
    const onVisible = () => { if (document.visibilityState === 'visible') pingSessionLog(); };
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      clearInterval(t);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [user]);
}
